import { createRouter, createWebHashHistory } from 'vue-router';
import AppContent from './AppContent.vue';
import RestaurantDetails from './components/RestaurantDetails.vue';

const routes = [
  {
    path: '/',
    name: 'stores',
    component: AppContent
  },
  {
    path: '/detail/:storeCode',
    name: 'detail',
    component: RestaurantDetails,
    props: true
  }
];

export default createRouter({
  history: createWebHashHistory(),
  routes
});
